import { useMemo } from "react"
import ItemSimple from "../Shared/ItemSimple"
import InputBoxCurrency from "../../../common/interactive/InputBoxCurrency"
import { totalItemsValue } from "../../../../lib/script"
import { cptOptions, returnLocationSOSFromId } from "../../../../lib/systemData"
import classes from '../Shared/Item.module.css'
import DaysDifference from "../notes/DaysDifference"
import { useUserTabEditPermissionDisabled } from "../../../../lib/usersPermissions"
import DefaultUpdater from "../../../common/DefaultUpdater"
import SosFooter from "./SosFooter"

const SOSItem = ({sosData, apiCase}) => {
    const viewCostOfGoodsPermission = useUserTabEditPermissionDisabled('sos_view_cost_of_goods')
    const viewPricePermission = useUserTabEditPermissionDisabled('sos_view_price')
    const rows = useMemo(() => {
        return [...(sosData || [])].sort((a, b) => {
            const dateA = a?.date_of_service ? String(a.date_of_service).slice(0, 10) : ''
            const dateB = b?.date_of_service ? String(b.date_of_service).slice(0, 10) : ''
            if (dateA !== dateB) {
                if (!dateA) return 1
                if (!dateB) return -1
                return dateB.localeCompare(dateA)
            }
            return Number(b.id) - Number(a.id)
        })
    }, [sosData])

    return <ItemSimple>
        <div className={classes.item_inner}>
            <div className={classes.item_left}>
                <div className={classes.items_overflow_container}>
                    <div className={classes.row}>
                        <table className="table-border-radius-8">
                            <thead>
                                <tr>
                                    <th className="table-cell-fit">Date of Service</th>
                                    <th>Account #</th>
                                    <th>Outside Location</th>
                                    <th className="table-cell-fit">CPT</th>
                                    <th className="table-cell-fit">Area</th>
                                    <th className="table-cell-fit">SOS Form Signed</th>
                                    <th className="table-cell-fit">Completed</th>
                                    {viewCostOfGoodsPermission && <th >Cost of Goods</th>}
                                    {viewPricePermission && <th >Retail Price</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((item) => (
                                    <tr key={item.id}>
                                        <td>
                                            <div className="flex-container gap-5 flex-container-end" style={{ flexWrap: "nowrap", alignItems: "center" }}>
                                                <div style={{ minWidth: 150, flex: "1 1 150px" }}>
                                                    <DefaultUpdater
                                                        type="date"
                                                        value={item.date_of_service}
                                                        name="date_of_service"
                                                        identifier={{type: apiCase, field: 'date_of_service', type_id: item.id, folder: 'case_sos'}}
                                                    />
                                                </div>
                                                <DaysDifference date={item.date_of_service} showZero />
                                            </div>
                                        </td>
                                        <td>
                                            <DefaultUpdater
                                                type="input"
                                                value={item.account_no}
                                                name="account_no"
                                                identifier={{type: apiCase, field: 'account_no', type_id: item.id, folder: 'case_sos'}}
                                                extraOptions={{bkTransparent: true, setStyle: 'simple'}}
                                            />
                                        </td>
                                        <td>{returnLocationSOSFromId(item.outside_location_id)?.companyName} - {returnLocationSOSFromId(item.outside_location_id)?.name}</td>
                                        <td>
                                            <DefaultUpdater
                                                type="select"
                                                value={item.cpt_id}
                                                options={cptOptions()}
                                                name="cpt_id"
                                                identifier={{type: apiCase, field: 'cpt_id', type_id: item.id, folder: 'case_sos'}}
                                                extraOptions={{fixedDrawer: true, minWidth: 125, complexLabel: true, forceShowApiLoader: true}}
                                            />
                                        </td>
                                        <td>
                                            <DefaultUpdater
                                                type="input"
                                                value={item.area}
                                                name="area"
                                                identifier={{type: apiCase, field: 'area', type_id: item.id, folder: 'case_sos'}}
                                                extraOptions={{bkTransparent: true, setStyle: 'simple', minWidth: 180}}
                                            />
                                        </td>
                                        <td>
                                            <DefaultUpdater
                                                type="checkbox"
                                                value={item.sos_form_signed}
                                                name="sos_form_signed"
                                                identifier={{type: apiCase, field: 'sos_form_signed', type_id: item.id, folder: 'case_sos'}}
                                                extraOptions={{setStyle: 'centered'}}
                                            />
                                        </td>
                                        <td>
                                            <DefaultUpdater
                                                type="checkbox"
                                                value={item.completed}
                                                name="completed"
                                                identifier={{type: apiCase, field: 'completed', type_id: item.id, folder: 'case_sos'}}
                                                extraOptions={{setStyle: 'centered'}}
                                            />
                                        </td>
                                        {viewCostOfGoodsPermission && <td className="table-cell-fit">
                                            <DefaultUpdater
                                                type="curency"
                                                value={item.cost_of_goods}
                                                name="cost_of_goods"
                                                identifier={{type: apiCase, field: 'cost_of_goods', type_id: item.id, folder: 'case_sos'}}
                                                extraOptions={{isNotModifiable: true, fixWidth: 150, textRight: true}}
                                            />
                                        </td>}
                                        {viewPricePermission && <td className="table-cell-fit">
                                            <DefaultUpdater
                                                type="curency"
                                                value={item.retail_price}
                                                name="retail_price"
                                                identifier={{type: apiCase, field: 'retail_price', type_id: item.id, folder: 'case_sos'}}
                                                extraOptions={{isNotModifiable: true, fixWidth: 150, textRight: true}}
                                            />
                                        </td>}
                                    </tr>
                                ))}                           

                                {/* //totals  */}
                                <tr>
                                    <td colSpan={7}>Totals</td>                                
                                    {viewCostOfGoodsPermission && <td>
                                        <InputBoxCurrency textRight={true} currentValue={Number(totalItemsValue(sosData, 'cost_of_goods').toFixed(2)) || 0} identifier={{type: apiCase, field: 'charges', type_id: null, folder: 'case_sos'}} isNotModifiable={true}/>
                                    </td>}
                                    {viewPricePermission && <td>
                                        <InputBoxCurrency textRight={true} currentValue={Number(totalItemsValue(sosData, 'retail_price').toFixed(2)) || 0} identifier={{type: apiCase, field: 'retail_price', type_id: null, folder: 'case_sos'}} isNotModifiable={true}/>
                                    </td>}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    

                    <SosFooter sosData={sosData} classes={classes}/>
                </div>
                
            </div>
        </div>
    </ItemSimple>
}

export default SOSItem
